import React, { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Col, Row } from 'react-bootstrap';
import { useAbility } from '@casl/react';
import { useReactToPrint } from 'react-to-print';
import { debounceLegalReportSimpleReport } from '../../requests/legalreports';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal, Icon } from '../../components';
import { AbilityContext } from '../../config/abilityContext';
import { downloadFile } from '../../services/utils';
import SimpleReportFilters from './Filters/SimpleReportFilters';
import WorkdayReportToPrint from './PrintComponent/WorkdayReportToPrint';
import { sendAlert } from '../../actions/utils';
import ReportActions from './ReportActions';
import SimpleReportsColumns from './SimpleReportsColumns';
import SimpleReportFilterDataTable from '../../components/SimpleReport';

export const WorkdayExpander = props => {
  const { data, setDocumentModalBody, setDocumentModalShow } = props;
  const { attendances, is_article_22: isArticle22, employee_id: employeeId } = data;

  return (
    <SimpleReportFilterDataTable
      attendances={attendances}
      isArticle22={isArticle22}
      employeeId={employeeId}
      setDocumentModalBody={setDocumentModalBody}
      setDocumentModalShow={setDocumentModalShow}
    />
  );
};

const SimpleReportDataTable = ({
  rrhh,
  filters: propFilters,
  moreData: propMoreData,
  setMoreData: propSetMoreData,
  isBoss
}) => {
  const [amount, setAmount] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [dataPrint, setDataPrint] = useState([]);
  const [isSubmitting, setSubmitting] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [moreData, setMoreData] = useState(false);
  const [onRequest, setOnRequest] = useState(false);
  const [searchFirstStart, setSearchFirstStart] = useState(false);
  const [tile, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [parameters, setParameters] = useState([]);
  const [filtersState, setFiltersState] = useState();
  const [showFilter, setShowFilter] = useState(true);
  const [documentModalShow, setDocumentModalShow] = useState(false);
  const [documentModalBody, setDocumentModalBody] = useState('');
  const [dateRange, setDateRange] = useState([]);

  const dispatch = useDispatch();
  const ability = useAbility(AbilityContext);
  const componentRef = useRef();

  const activeMoreData = typeof propMoreData !== 'undefined' ? propMoreData : moreData;

  const printInfo = useReactToPrint({
    content: () => componentRef.current
  });

  const handleFailureRequest = error => {
    const message = error?.response?.data?.message || 'TRABAJADOR NO ENCONTRADO';
    dispatch(sendAlert({ kind: 'error', message }));
  };

  const handleRequest = (params, format = null, type = 'json') => {
    const responseType = params.type === '.docx' ? 'blob' : type;
    const responseFormat = format === '.print' ? '.json' : format;
    const customParams = {
      ...params
    };
    setOnRequest(true);
    setSubmitting(true);
    debounceLegalReportSimpleReport({
      dispatch,
      params: {
        display_start: 0,
        display_length: 15,
        ...customParams,
        sort_direction: 'asc',
        sort_column: 'name',
        is_dt: false,
        paginate: format === null
      },
      format: responseFormat,
      responseType,
      successCallback: response => {
        const { data } = response;
        if (format === '.xlsx' || format === '.docx' || format === '.pdf') {
          downloadFile(response);
        } else if (format === '.print') {
          setSubmitting(false);
          setDataPrint(data.data);
          printInfo();
        } else {
          setAmount(data.metadata.amount);
          setEmployees(data.data);
        }
      },
      failureCallback: handleFailureRequest,
      callback: () => {
        setOnRequest(false);
        setSubmitting(false);
      }
    });
  };

  const handleMassAction = action => {
    switch (action) {
      case 'download_excel':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Excel?');
        setParameters([{ ...filtersState, type: '.xlsx' }, '.xlsx', 'text']);
        setModalShow(true);
        break;
      case 'download_docx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Word?');
        setParameters([{ ...filtersState, type: '.docx' }, '.docx', 'text']);
        setModalShow(true);
        break;
      case 'download_pdf':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato PDF?');
        setParameters([{ ...filtersState, type: '.pdf' }, '.pdf', 'text']);
        setModalShow(true);
        break;
      case 'print':
        setTitle('Imprimir Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres imprimir el reporte de jornada diaria?');
        setParameters([{ ...filtersState, type: '.print' }, '.print', 'text']);
        setModalShow(true);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const handleFilterAdvance = async params => {
    setFiltersState(params);
    setDateRange(params.range_date_workday);
    switch (params.type) {
      case null:
        setSearchFirstStart(true);
        if (typeof propSetMoreData === 'function') propSetMoreData(!propMoreData);
        else setMoreData(prev => !prev);
        setShowFilter(false);
        break;
      case '.docx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Word?');
        setParameters([params, '.docx', 'text']);
        setModalShow(true);
        break;
      case '.xlsx':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato Excel?');
        setParameters([params, '.xlsx', 'text']);
        setModalShow(true);
        break;
      case '.pdf':
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres exportar el reporte de jornada diaria en formato PDF?');
        setParameters([params, '.pdf', 'text']);
        setModalShow(true);
        break;
      case '.print':
        setTitle('Imprimir Reporte de Jornada Diaria');
        setBody('¿Estás seguro que quieres imprimir el reporte de jornada diaria?');
        setParameters([params, '.print', 'text']);
        setModalShow(true);
        break;
      default:
        break;
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'branch_office_address':
        return { sort_branch_offices: name };
      default:
        return { sort_column: name };
    }
  };

  const handleRawFilters = () => {
    const incoming = propFilters;
    if (!incoming || Object.keys(incoming).length === 0) return;

    setFiltersState({ ...incoming });
    setDateRange(incoming.range_date_workday || []);

    if (['.docx', '.xlsx', '.pdf', '.print'].includes(incoming.type)) {
      const { type } = incoming;
      setSubmitting(true);
      if (['.xlsx', '.pdf', '.docx'].includes(type)) {
        setTitle('Exportar Reporte de Jornada Diaria');
        setBody(
          `¿Estás seguro que quieres exportar el reporte de jornada diaria en formato ${type
            .replace('.', '')
            .toUpperCase()}?`
        );
        setParameters([incoming, type, type === '.docx' ? 'blob' : 'text']);
        setModalShow(true);
        setSubmitting(false);
        return;
      }
      if (type === '.print') {
        handleRequest(incoming, '.print', 'text');
        return;
      }
    }

    setSearchFirstStart(true);
    if (typeof propSetMoreData === 'function') propSetMoreData(!propMoreData);
    else setMoreData(prev => !prev);
    setShowFilter(incoming.type === '.print');

    // lanzar petición con filtros entrantes
    handleRequest(incoming);
  };

  useEffect(handleRawFilters, [propFilters]);

  return (
    <>
      <div className={showFilter ? '' : 'd-none'}>
        <SimpleReportFilters
          filterRRHH={rrhh}
          formRequest={handleFilterAdvance}
          isSubmit={isSubmitting}
          onRequest={onRequest}
          onlyPreview
        />
      </div>

      <div className={showFilter ? 'd-none' : ''}>
        {!isBoss && (
          <Row>
            <Col md={6} className="mt-3">
              <Button variant="primary" onClick={() => setShowFilter(true)}>
                <Icon icon="chevron-back" width={15} />
                <span className="arial-dt">Volver al filtro</span>
              </Button>
            </Col>
          </Row>
        )}

        <ComponentDataTable
          onRequest={onRequest}
          columns={SimpleReportsColumns()}
          moreData={activeMoreData}
          data={employees}
          responsive
          totalRows={amount}
          handleSortCase={sortColumnCase}
          withMassActions={ability.can('index', 'WorkdayReport')}
          massActions={
            <ReportActions disabled={onRequest} handleClick={handleMassAction} dates={dateRange} attrr downloadPdf />
          }
          resourceRequest={params => {
            handleRequest({ ...params, ...filtersState });
          }}
          expandableRows
          expandableRowExpanded={() => true}
          expandableRowsComponent={
            <WorkdayExpander setDocumentModalBody={setDocumentModalBody} setDocumentModalShow={setDocumentModalShow} />
          }
          searchFirstStart={searchFirstStart}
          noDataComponentText="NO HAY TRABAJADORES QUE COINCIDAN CON LA SELECCIÓN"
        />
      </div>

      <div style={{ display: 'none' }}>
        <WorkdayReportToPrint data={dataPrint} ref={componentRef} />
      </div>
      <DefaultModal
        title={tile}
        body={body}
        show={modalShow}
        handleClose={() => {
          setModalShow(false);
          setSubmitting(false);
        }}
        handleConfirm={() => {
          handleRequest(...parameters);
          setModalShow(false);
        }}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
      <SimpleCenteredModal
        body={documentModalBody}
        onHide={() => setDocumentModalShow(false)}
        show={documentModalShow}
        size="xl"
      />
    </>
  );
};

export default SimpleReportDataTable;
